import React from 'react';
import Hero from '../components/Hero';
import Paths from '../components/home/Paths';
import Authority from '../components/home/Authority';
import FeaturedProducts from '../components/home/FeaturedProducts';
import LocalWork from '../components/home/LocalWork';
import Services from '../components/home/Services';
import Capabilities from '../components/home/Capabilities';
import WhyUs from '../components/home/WhyUs';
import Process from '../components/home/Process';
import CTA from '../components/home/CTA';

const Home = () => {
  return (
    <div className="overflow-hidden">
      <Hero />
      <Paths />
      <Authority />
      <FeaturedProducts />
      <LocalWork />
      <Services />
      <Capabilities />
      <WhyUs />
      <Process />
      <CTA />
    </div>
  );
};

export default Home;